import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v3/celery/inspectactive`;
export const QueryKey = () => ['v3', 'admin', 'celery', 'activeTasks'] as const;
export type Payload = never;
export type Response = Record<string, Models.Celery.ActiveTask[]>;
